import React from 'react';
import PropTypes from 'prop-types';
import useServicePlanTiers from '../../hooks/useServicePlanTiers/useServicePlanTiers';

const ReconnectPlanPromo = ({ onComparePlans }) => {
  const {
    tiersLoading,
    tiersError,
    getTierYearlyPrice,
    lowestPaidTier,
  } = useServicePlanTiers();

  if (tiersLoading || tiersError || !lowestPaidTier) {
    return null;
  }

  const monthlyPrice = getTierYearlyPrice(lowestPaidTier) / 12;

  return (
    <div className="card mb-4">
      <div className="card-body text-center py-4">
        <h5 className="mb-2">
          Reconnect your
          <br />
          Room Alert Monitors
          <br />
          for as little as
        </h5>

        <div className="font-weight-bold text-danger mb-1" style={{ fontSize: '2rem' }}>
          $
          {monthlyPrice.toFixed(2)}
        </div>

        <div className="small text-muted mb-3">
          per month, billed annually.
        </div>

        <button
          type="button"
          className="btn btn-primary btn-sm font-weight-bold px-4"
          onClick={onComparePlans}
        >
          Compare Plans
        </button>
      </div>
    </div>
  );
};

ReconnectPlanPromo.propTypes = {
  onComparePlans: PropTypes.func.isRequired,
};

export default ReconnectPlanPromo;
